import oceanBeachTheme from 'typography-theme-ocean-beach'

import { TypographyOptions } from './types'

export const typography: TypographyOptions = {
  ...oceanBeachTheme,
  baseFontSize: '16px',
}
